<template>
	<div class="polygon-autocomplete">
		<v-text-field
			id="polygon-input"
			:label="placeholder"
			:value="displayValue"
			:placeholder="placeholder"
			outlined
			dense
			hide-details
			@input="handleInput"
			@focus="showMenu = true"
			@blur="closeMenu"
			class="custom-height-search custom-height-calendar flex-grow-0"
			style="min-width: 220px;width: 220px;max-width: 220px;"
		/>
		<div
			v-if="showMenu"
			class="polygon-menu"
			@mousedown.prevent
		>
			<v-list v-if="filteredItems.length > 0" style="max-height: 250px; overflow-y: auto;">
				<v-list-item
					v-for="item in filteredItems"
					:key="`${item.name}-${item.price}`"
					@click="selectItem(item)"
					class="cursor-pointer"
				>
					<v-list-item-content>
						<v-list-item-title>
							<div class="d-flex align-center justify-space-between">
								<p class="mb-0 flex-1 caption">{{ item.name }}</p>
								<p class="mb-0 font-weight-bold">
									${{ item.price | toThousandFilter }}
								</p>
							</div>
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
			<div v-else class="pa-3 text-center grey--text">
				No hay coincidencias
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PolygonAutoComplete',
	props: {
		value: {
			type: [String, Number],
			default: null
		},
		items: {
			type: Array,
			default: () => []
		},
		placeholder: {
			type: String,
			default: 'Seleccione un área o ingrese un valor'
		}
	},
	data() {
		return {
			showMenu: false,
			searchText: ''
		}
	},
	computed: {
		filteredItems() {
			return this.items
		},
		displayValue() {
			if (this.value === null || this.value === '') {
				return ''
			}
			const numValue = Number(this.value)
			if (!isNaN(numValue)) {
				const formatted = numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
				return '$' + formatted
			}
			return this.value
		}
	},
	watch: {
		value(newVal) {
			if (newVal === null || newVal === '') {
				this.searchText = ''
			} else {
				const item = this.items.find(i => i.price === newVal || String(i.price) === String(newVal))
				if (item) {
					this.searchText = item.name
				} else {
					this.searchText = String(newVal)
				}
			}
		}
	},
	methods: {
		handleInput(text) {
			this.searchText = text
			if (text === '') {
				this.$emit('input', null)
			} else {
				const cleanText = text.replace(/\$/g, '').replace(/\./g, '')
				const numValue = Number(cleanText)
				if (!isNaN(numValue) && cleanText.trim() !== '') {
					this.$emit('input', numValue)
				} else {
					this.$emit('input', cleanText || text)
				}
			}
		},
		selectItem(item) {
			this.searchText = item.name
			this.$emit('input', item.price)
			this.showMenu = false
		},
		closeMenu() {
			// Usa setTimeout para permitir que se registre el click en los items
			setTimeout(() => {
				this.showMenu = false
			}, 100)
		}
	}
}
</script>

<style scoped>
.polygon-autocomplete {
	position: relative;
}
.polygon-menu {
	position: absolute;
	top: -260px;
	width: 220px;
	background: white;
	border: 1px solid #e0e0e0;
	border-radius: 4px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	z-index: 2000;
}
.cursor-pointer {
	cursor: pointer;
}
.cursor-pointer:hover {
	background-color: rgba(0, 0, 0, 0.05);
}
</style>
